import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ScoringLoader from 'general/js/loaders/scoring-loader';
import { BlockPlaceholder } from 'components/block-placeholder';
import { BlockSpinner } from 'components/block-spinner';
import QualDrawContainer from './qual-draw-container';
import { bemClasses, LivePreMessage } from '../../live-pre-message';
import { getLocationNameToFilterBy } from './action-helper';

class QualDrawLayout extends React.Component {
    componentDidMount() {
        ScoringLoader.subscribe(`draw${this.props.options.type}`);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(`draw${this.props.options.type}`);
    }

    render() {
        const { scoringDraw } = this.props;

        if (scoringDraw === undefined) {
            return (
                <BlockPlaceholder minHeight={300}>
                    <BlockSpinner />
                </BlockPlaceholder>
            );
        }

        if (!scoringDraw || !Array.isArray(scoringDraw.players)) {
            return <LivePreMessage bemList={[bemClasses.DARK]} />;
        }

        const players = [...scoringDraw.players].sort((a, b) => {
            return a.r1TeeTime.localeCompare(b.r1TeeTime);
        });

        const locationName = getLocationNameToFilterBy(players, this.props.options.locationIdToFilterBy);

        return (
            <QualDrawContainer
                {...this.props}
                players={players}
                locationNameToFilterBy={locationName}
            />
        );
    }
}

QualDrawLayout.propTypes = {
    options: PropTypes.shape({
        type: PropTypes.string,
        infoPopupUrl: PropTypes.string
    }),
};

const mapStateToProps = (state, ownProps) => ({
    scoringDraw: state.scoring[`draw${ownProps.options.type}`]
});

const QualDrawLayoutWrapper = connect(
    mapStateToProps
)(QualDrawLayout);

export default QualDrawLayoutWrapper;
